import { useFetch } from '@reveni-io/reveni-ui'

import parcelServices from '@/parcels/services/services'
import { transformResponseParcelDetail } from '@/parcels/transformers/parcels/transformers'

const useParcel = ({ id, storeId }) => {
  const {
    data: parcel,
    fetchData: fetchParcel,
    loading,
  } = useFetch(() => parcelServices.getParcel({ parcelId: id, storeId }), {
    doInitialRequest: true,
    transformResponse: transformResponseParcelDetail,
  })

  return {
    parcel,
    loading,
    getParcel: fetchParcel,
  }
}

export default useParcel
